import { getName, OntologyType } from "core/model/utils/ontologies";
import { useGetOntologies } from "core/model/utils/ontologies/hooks";
import CheckboxGroup, {
  CheckboxGroupBaseProps,
} from "ds_legacy/components/CheckboxGroup";
import { getOrderedItems } from "ds_legacy/components/ChipGroup";
import { CSSProperties } from "react";
import { useTranslations } from "translations";

export type OntologyCheckboxGroupProps = CheckboxGroupBaseProps & {
  captions?: AnyObject;
  isRequired?: boolean;
  labelStyle?: CSSProperties;
  order?: AnyObject;
  shouldSort?: boolean;
  type: OntologyType;
};

export function useOntologyCheckboxGroup({
  captions,
  order,
  shouldSort,
  type,
}: Pick<
  OntologyCheckboxGroupProps,
  "captions" | "shouldSort" | "type" | "order"
>) {
  const getOntologies = useGetOntologies();
  const values = getOntologies({ sort: shouldSort, type });
  const sortedValues = getOrderedItems(order, values);

  return sortedValues.map((item) => ({
    id: item.value,
    label: item.name,
    RadioCaption:
      captions &&
      Object.keys(captions).filter((key: ToType) => key == item.value)
        .length === 1
        ? captions[item.value]
        : undefined,
  }));
}

export default function OntologyCheckboxGroup({
  captions,
  elementName,
  exclude,
  formControlStyle,
  include,
  isRequired,
  label,
  labelStyle,
  labelWrapperStyle,
  order,
  shouldSort,
  sideMutation,
  type,
  wrapperStyle,
}: OntologyCheckboxGroupProps) {
  const translations = useTranslations();
  const items = useOntologyCheckboxGroup({ captions, order, shouldSort, type });

  return (
    <CheckboxGroup
      elementName={elementName}
      exclude={exclude}
      formControlStyle={formControlStyle}
      include={include}
      isRequired={isRequired}
      items={items}
      label={label != null ? label : getName(type, translations)}
      labelStyle={labelStyle}
      labelWrapperStyle={labelWrapperStyle}
      sideMutation={sideMutation}
      wrapperStyle={wrapperStyle}
    />
  );
}
